import pkg from '../package.json';
import Player from './models/player';
import Metadata from './models/metadata';
import EmbedView from './views/embed';
import {
  DEFAULTS,
  CONFIG_NAMESPACE,
  MODAL_LAYER_ID,
  VIDEOPLAYER_REFRESH_EVENT
} from './constants';

const {$} = Voonto;
var _players$;

Voonto.ready.then((app) => {
  const config = app.lookup(CONFIG_NAMESPACE);
  if (!config.serviceUrl) {throw Error(`[VideoPlayer] service url is not defined within ${CONFIG_NAMESPACE}`);}

  if (!$(`#${MODAL_LAYER_ID}`).length) {
    $('body').append(`<div id="${MODAL_LAYER_ID}"></div>`);
  }

  _buildEmbedViews(config);
  app.on(VIDEOPLAYER_REFRESH_EVENT, function(event, data) {
      _buildEmbedViews(config, data);
  });

});

export const VERSION = pkg.version;

/* Private */
function _buildEmbedViews(config, container$) {
  _players$ = container$ ? container$.find('[data-voc-video-player]') : $('[data-voc-video-player]');
  _players$.each(function() {
    let container$ = $(this);
    let options = {}, metadata, player;

    $.extend(options, DEFAULTS, {
      source:              container$.data('voc-video-player-source'),
      accountname:         container$.data('voc-video-player-accountname'),
      videoid:             container$.data('voc-video-player-videoid'),
      autoplay:            container$.data('voc-video-player-autoplay'),
      author:              container$.data('voc-video-player-author'),
      bumperid:            container$.data('voc-video-player-bumperid'),
      controls:            container$.data('voc-video-player-controls'),
      description:         container$.data('voc-video-player-description'),
      domain:              container$.data('voc-video-player-domain'),
      edition:             container$.data('voc-video-player-edition'),
      link:                container$.data('voc-video-player-link'),
      loop:                container$.data('voc-video-player-loop'),
      longdescription:     container$.data('voc-video-player-longdescription'),
      modallayer:          container$.data('voc-video-player-modallayer'),
      muted:               container$.data('voc-video-player-muted'),
      name:                container$.data('voc-video-player-name'),
      newsid:              container$.data('voc-video-player-newsid'),
      playerid:            container$.data('voc-video-player-playerid'),
      playlistid:          container$.data('voc-video-player-playlistid'),
      playlistorientation: container$.data('voc-video-player-playlistorientation'),
      playsinline:         container$.data('voc-video-player-playsinline'),
      poster:              container$.data('voc-video-player-poster'),
      template:            container$.data('voc-video-player-template'),
      src:                 container$.data('voc-video-player-src'),
      videoad:             container$.data('voc-video-player-videoad'),
      videolive:           container$.data('voc-video-player-videolive')
    });

    metadata = new Metadata(options, config.serviceUrl);
    player = new Player(options, config.serviceUrl);
    new EmbedView({metadata, player, container$});
  });
}



// WEBPACK FOOTER //
// ./src/index.js